// ─── Review queue helpers (V9-p) ──────────────────────────────────────────────
//
// Pure functions, kept out of ReviewQueueTab.jsx so that file only exports
// components (react-refresh) and so these are unit-testable on their own.
// They are the two places the tab can be wrong without any render showing
// it: a score that is not what `admin-attempts_score` accepts, and a refusal
// shown to the admin as a raw English code.

/** How many recent `failed` takes the tab lists next to the queue. */
export const FAILED_LIMIT = 50

/**
 * The refusals of `admin-attempts_score` / `_reanalyze` in the admin's own
 * language, or null when this is not one of them — the caller then falls
 * back to `errorMessage`, which prefers whatever the server said.
 *
 * `admin_jwt_required` is the one an admin will actually hit: the panel
 * works perfectly well on the shared key until the moment they try to score,
 * because an audit row needs a person, so the message has to say what to do
 * about it rather than just "403".
 */
export function refusalMessage(error) {
  const code = error?.response?.data?.error
  if (code === 'attempt_already_scored') return 'این تلاش قبلاً امتیاز گرفته است. فهرست را تازه کنید.'
  if (code === 'attempt_not_scorable') return 'این تلاش همین حالا در حال ارسال یا تحلیل است؛ چند لحظهٔ دیگر دوباره امتحان کنید.'
  if (code === 'attempt_not_found') return 'این تلاش دیگر وجود ندارد.'
  if (code === 'admin_jwt_required' || error?.response?.status === 403) {
    return 'امتیاز دستی فقط با ورود شخصی (شماره و کد) ممکن است؛ کلید مشترک نمی‌تواند در گزارش ممیزی ثبت شود.'
  }
  return null
}

/**
 * The score field's text into the whole 0–100 the API wants. Throws a
 * Persian message for anything else — a fraction included, since the backend
 * takes whole numbers and a silently rounded 84.6 is not what the admin
 * meant to credit.
 */
export function parseManualScore(text) {
  const trimmed = String(text).trim()
  const n = Number(trimmed)
  if (trimmed === '' || !Number.isInteger(n) || n < 0 || n > 100) {
    throw new Error('امتیاز کلی باید عددی درست بین ۰ تا ۱۰۰ باشد.')
  }
  return n
}
